import {
  DateFormats,
  formatISODate,
  formatNumber,
} from '@omnipresentgroup/design-system';
import { toSentenceCase } from '@omnipresentgroup/helpers';
import {
  CompensationConfigRecurrence,
  type CompensationVariantPayment,
} from '@omnipresentgroup/types';

import {
  CompensationSourceTag,
  VariantPaymentState,
} from '../../../features/variant-payments';

export const VARIANT_PAYMENT_ENTRIES: {
  key: keyof CompensationVariantPayment;
  label: string;
}[] = [
  {
    key: 'source',
    label: 'Category',
  },
  {
    key: 'recurrence',
    label: 'Recurrence',
  },
  {
    key: 'amount',
    label: 'Gross amount',
  },
  {
    key: 'effectiveDate',
    label: 'Effective start date',
  },
  {
    key: 'endDate',
    label: 'Effective end date',
  },
  {
    key: 'requestedAt',
    label: 'Requested at',
  },
  {
    key: 'isMandatory',
    label: 'Mandatory',
  },
  {
    key: 'state',
    label: 'State',
  },
];

export const RENDERER_MAPPING: {
  [K in keyof Partial<CompensationVariantPayment>]?: (
    variantPayment: CompensationVariantPayment,
  ) => string | JSX.Element;
} = {
  amount: ({ amount }: CompensationVariantPayment) =>
    formatNumber({ input: Number(amount.amount), currency: amount.currency }),
  state: (variantPayment: CompensationVariantPayment) => (
    <VariantPaymentState variantPayment={variantPayment} />
  ),
  recurrence: ({ recurrence }: CompensationVariantPayment) =>
    toSentenceCase(recurrence),
  isMandatory: ({ isMandatory }: CompensationVariantPayment) =>
    isMandatory ? 'Yes' : 'No',
  source: ({ source }: CompensationVariantPayment) => (
    <CompensationSourceTag source={source} />
  ),
  effectiveDate: ({ effectiveDate }: CompensationVariantPayment) =>
    formatISODate(effectiveDate, DateFormats.Date),
  endDate: ({ recurrence, endDate }: CompensationVariantPayment) =>
    endDate
      ? formatISODate(endDate, DateFormats.Date)
      : // eslint-disable-next-line unicorn/no-nested-ternary
        recurrence === CompensationConfigRecurrence.MONTHLY
        ? 'Contract end'
        : '-',
  requestedAt: ({ requestedAt }: CompensationVariantPayment) =>
    formatISODate(requestedAt, DateFormats.Date),
};
